module.exports = __webpack_public_path__ + "img/tonearm-straight-black.863223a4.png";